import { Shield, Database, Scale, Activity, FileText, Clock } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const conditions = [
  {
    icon: Shield,
    title: "Ransomware-Schutz",
    items: [
      "Lösegeldzahlungen bis Deckungssumme",
      "IT-Forensik & Wiederherstellung",
      "Krisenmanagement & PR-Beratung",
      "Präventions-Workshops nach Vorfall",
    ],
  },
  {
    icon: Database,
    title: "Datenwiederherstellung",
    items: [
      "Professionelle Datenrettung",
      "Rekonstruktion von Patientendaten",
      "Backup-Systeme Neuaufbau",
      "Cloud-Migration Unterstützung",
    ],
  },
  {
    icon: Scale,
    title: "DSGVO-Rechtsbeistand",
    items: [
      "Anwaltskosten bei Bußgeldverfahren",
      "Meldepflicht-Unterstützung",
      "Betroffenen-Kommunikation",
      "Behörden-Korrespondenz",
    ],
  },
  {
    icon: Activity,
    title: "Betriebsausfall-Absicherung",
    items: [
      "Verdienstausfall-Erstattung",
      "Fixkosten-Übernahme (Miete, Gehälter)",
      "Notfall-IT-Infrastruktur Bereitstellung",
      "Bis zu 90 Tage Ausfallzeit",
    ],
  },
  {
    icon: FileText,
    title: "Versicherungssummen",
    items: [
      "Basis-Tarif: ab 250.000 €",
      "Komfort-Tarif: ab 500.000 €",
      "Premium-Tarif: ab 1.000.000 €",
      "Individuelle Anpassung möglich",
    ],
  },
  {
    icon: Clock,
    title: "Wartezeiten & Laufzeit",
    items: [
      "Keine Wartezeit bei Erstabschluss",
      "Mindestlaufzeit: 12 Monate",
      "Monatliche Kündigungsfrist: 3 Monate",
      "Sofortschutz ab Vertragsbestätigung",
    ],
  },
];

const ConditionsAccordion = () => {
  return (
    <section className="py-8 sm:py-12 lg:py-16 relative">
      <div className="container mx-auto max-w-4xl px-3 sm:px-4 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 lg:mb-12">
          <h2 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold mb-3 sm:mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary via-accent to-primary">
            Was ist versichert?
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Umfassender Schutz für alle Eventualitäten
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-2.5 sm:space-y-3">
          {conditions.map((condition, index) => {
            const Icon = condition.icon;
            return (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card/30 backdrop-blur-sm border border-border/50 rounded-lg px-4 sm:px-6 overflow-hidden hover:border-accent/50 hover:bg-card/50 transition-all data-[state=open]:border-accent"
              >
                <AccordionTrigger className="hover:no-underline py-4 sm:py-5">
                  <div className="flex items-center gap-3 sm:gap-4 text-left">
                    <div className="p-2.5 sm:p-3 rounded-2xl bg-accent/10 border border-accent/20 flex-shrink-0">
                      <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-accent" />
                    </div>
                    <span className="text-base sm:text-lg font-bold text-foreground">
                      {condition.title}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-4 sm:pb-5 pt-2">
                  <ul className="space-y-2 ml-10 sm:ml-12 lg:ml-[60px]">
                    {condition.items.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className="flex items-start gap-2 text-xs sm:text-sm text-muted-foreground"
                      >
                        <span className="text-accent mt-0.5">✓</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
};

export default ConditionsAccordion;
